import React from 'react'
import { Meta } from '../../../Meta'

const ArticleV2SEO = ({data}) => {
    const seo = data.seo || {};
    
    return (
        <Meta title={seo.title} description={seo.description} image={seo.image}/>
    )
}

export default ArticleV2SEO